import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import {
  POSTProgramCatalogItem,
  PostProgramCatalogItemPayload,
} from '../requests'

type CategoryData = unknown // The return type of your mutation
type CategoryError = unknown // The error type
type CategoryVariables = unknown // The variables type
type Options = Omit<
  UseMutationOptions<CategoryData, CategoryError, CategoryVariables>,
  'mutationFn'
>

export const usePostProgramCatalogItem = (options: Options) => {
  return useMutation({
    mutationFn: async (payload: PostProgramCatalogItemPayload) => {
      return POSTProgramCatalogItem(payload)
    },
    mutationKey: [],
    ...options,
  })
}
